import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { getCognitoUser } from "../common/auth";
import { log } from "../common/logger";
import { setCurrentAuthenticatedUser } from "../core/authenticated-user";

const logger = log("ProvideAuthenticatedUserGuard");

@Injectable()
export class ProvideAuthenticatedUserGuard {
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const cognitoUser = await getCognitoUser();

    logger.info(cognitoUser);

    setCurrentAuthenticatedUser({
      email: cognitoUser.attributes.email,
      familyName: cognitoUser.attributes.family_name,
      id: cognitoUser.attributes.sub,
      name: cognitoUser.attributes.name
    });

    return true;
  }
}
